
























import { Component, Vue, Prop } from 'vue-property-decorator';
import MoveableElement from './MoveableElement.vue';
import TextElement from './TextElement.vue';
import ImageElement from './ImageElement.vue';
import AudioElement from './AudioElement.vue';
import VideoElement from './VideoElement.vue';
import PdfElement from './PdfElement.vue';
import DrawingElement from './DrawingElement.vue';
import YoutubeElement from './YoutubeElement.vue';
import OfficeElement from './OfficeElement.vue';
import UploadBoxElement from './UploadBoxElement.vue';
import { Getter } from 'vuex-class';
import { RootGettersReturns } from '../../../store/types';

@Component({
  components: {
    MoveableElement,
    TextElement,
    ImageElement,
    AudioElement,
    VideoElement,
    PdfElement,
    DrawingElement,
    YoutubeElement,
    OfficeElement,
    UploadBoxElement,
  },
})
export default class ElementHolder extends Vue {
  @Getter boardElements!: RootGettersReturns['boardElements'];

  @Prop(Function) getZoom!: () => number;
  @Prop(Boolean) spacePressed!: boolean;
  @Prop(Boolean) isFreeHand!: boolean;
}
